import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { SCHOLAR_COLORS, scholarInitial, STORAGE_BASE, CONTACT_API } from '../utils/api';

function catName(c, lang) {
  if (!c) return '';
  if (lang === 'ar') return c.name_ar || '';
  if (c.translations && c.translations[lang] && c.translations[lang].name) {
    return c.translations[lang].name;
  }
  if (lang === 'en') return c.name_en || c.name_ar || '';
  return c.name_ar || '';
}

export function CausesPage() {
  const { t } = useLang();
  const navigate = useNavigate();

  const causes = [
    { img:'https://images.unsplash.com/photo-1542382257-80dedb977a5c?w=600&q=80', badge:'🇵🇸', badgeKey:'cau.tab.pal',  bc:'ccat-r', titleKey:'cau.c1.title', bodyKey:'cau.c1.body', scholar:'د. خالد نصر', date:'منذ ٣ أيام' },
    { img:'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&q=80', badge:'🌍', badgeKey:'cau.tab.west', bc:'ccat-b', titleKey:'cau.c2.title', bodyKey:'cau.c2.body', scholar:'أ. سيد عبد السميع', date:'منذ أسبوع' },
    { img:'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&q=80', badge:'📚', badgeKey:'cau.tab.min',  bc:'ccat-o', titleKey:'cau.c3.title', bodyKey:'cau.c3.body', scholar:'د. خالد نصر', date:'منذ شهر' },
  ];

  // Cause card titles/bodies use the existing translation system

  // Merge into TRANSLATIONS on fly
  const tc = (key) => {
    const entry = causeData[key];
    const { lang } = useLang();
    return entry ? (entry[lang]||entry.ar) : key;
  };

  return (
    <div id="page-causes">
      <div style={{position:'relative',overflow:'hidden',minHeight:380,display:'flex',alignItems:'flex-end'}}>
        <div className="causes-ph-bg"><img src="https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1400&q=80" alt=""/></div>
        <div className="causes-ph-ov"/><div className="geo-pattern"/>
        <div className="causes-ph-content">
          <div className="causes-badge">{t('cau.badge')}</div>
          <h1>{t('cau.title1')} <em>{t('cau.title2')}</em></h1>
          <p>{t('cau.subtitle')}</p>
        </div>
      </div>
      <div style={{maxWidth:1380,margin:'0 auto',padding:'0 1.5rem'}}>
        <div className="causes-tabs">
          <button className="ctab on">{t('cau.tab.all')}</button>
          <button className="ctab r">{t('cau.tab.pal')}</button>
          <button className="ctab">{t('cau.tab.west')}</button>
          <button className="ctab">{t('cau.tab.min')}</button>
          <button className="ctab">{t('cau.tab.women')}</button>
        </div>
        <div className="urg-bar">
          <div className="urg-icon">🇵🇸</div>
          <div className="urg-body">
            <h3>{t('cau.urg.title')}</h3>
            <p>{t('cau.urg.body')}</p>
          </div>
          <button className="urg-btn">{t('cau.urg.btn')}</button>
        </div>
        <div className="causes-grid">
          {causes.map((c,i)=>(
            <div key={i} className="ccard-new" style={{cursor:'pointer'}}>
              <div className="ccard-img-h">
                <img src={c.img} alt=""/>
                <span className={`ccat-badge ${c.bc}`}>{c.badge} {t(c.badgeKey)}</span>
              </div>
              <div className="ccard-bdy">
                <h3>{t(c.titleKey)}</h3>
                <p>{t(c.bodyKey)}</p>
                <div className="ccard-foot">
                  <span className="ccard-sch">👤 {c.scholar}</span>
                  <span className="ccard-date">{c.date}</span>
                </div>
                <button className="read-more">{t('cau.read.more')}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function YouthPage() {
  const { t } = useLang();
  const navigate = useNavigate();

  const qCards = [
    { emoji:'💑', titleKey:'youth.q1.title2', bodyKey:'youth.q1.body2' },
    { emoji:'🎵', titleKey:'youth.q2.title2', bodyKey:'youth.q2.body2' },
    { emoji:'🏦', titleKey:'youth.q3.title2', bodyKey:'youth.q3.body2' },
  ];
  const i101 = [
    { icon:'☪️', titleKey:'youth.i101.1.title2', bodyKey:'youth.i101.1.body2', bg:'linear-gradient(135deg,#1a3a2a,#2c5f3f)' },
    { icon:'📿', titleKey:'youth.i101.2.title2', bodyKey:'youth.i101.2.body2', bg:'linear-gradient(135deg,#1a2a4a,#2a4a7a)' },
    { icon:'📖', titleKey:'youth.i101.3.title2', bodyKey:'youth.i101.3.body2', bg:'linear-gradient(135deg,#3a1a0a,#7a4020)' },
    { icon:'🕌', titleKey:'youth.i101.4.title2', bodyKey:'youth.i101.4.body2', bg:'linear-gradient(135deg,#0a2a3a,#1a5a7a)' },
  ];

  return(
    <div id="page-youth">
      <div className="youth-hero-section">
        <div className="geo-pattern"/><div className="y-glow1"/><div className="y-glow2"/>
        <div className="y-badge">{t('youth.badge')}</div>
        <h1>{t('youth.title1')} <em>{t('youth.title2')}</em></h1>
        <p>{t('youth.subtitle')}</p>
        <div className="y-btns">
          <button className="y-btn-p" onClick={()=>navigate('/contact')}>{t('youth.btn.ask')}</button>
          <button className="y-btn-g" onClick={()=>navigate('/lectures')}>{t('youth.btn.watch')}</button>
        </div>
      </div>
      <div style={{maxWidth:1380,margin:'0 auto',padding:'0 1.5rem'}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',margin:'1.4rem 0 1rem',paddingBottom:'.5rem',borderBottom:'2px solid var(--gp)'}}>
          <h2 style={{fontFamily:'var(--fam-display)',fontSize:'var(--t-xl)',color:'var(--g1)'}}>{t('youth.qa.section.title')}</h2>
          <a href="/fatwas" onClick={e=>{e.preventDefault();navigate('/fatwas');}} style={{fontSize:'var(--t-sm)',color:'var(--g1)',fontWeight:700,border:'1.5px solid var(--gp)',padding:'.26rem .85rem',borderRadius:20}}>
            {t('youth.view.all')}
          </a>
        </div>
        <div className="q-grid">
          {qCards.map((c,i)=>(
            <div key={i} className="qcard-y" onClick={()=>navigate('/fatwas')}>
              <div className="q-emoji">{c.emoji}</div>
              <h4>{t(c.titleKey)}</h4>
              <p>{t(c.bodyKey)}</p>
              <span className="q-arrow">{t('youth.read.answer')}</span>
            </div>
          ))}
        </div>
        <div className="i101-row">
          {i101.map((c,i)=>(
            <div key={i} className="i101c">
              <div className="i101-top" style={{background:c.bg}}><div className="i101-ico">{c.icon}</div></div>
              <div className="i101-bdy"><h4>{t(c.titleKey)}</h4><p>{t(c.bodyKey)}</p></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function AboutPage({ scholars, categories }) {
  const { t, lang } = useLang();
  const navigate = useNavigate();

  const values = [
    { titleKey:'ab.val1.title2', bodyKey:'ab.val1.body2' },
    { titleKey:'ab.val2.title2', bodyKey:'ab.val2.body2' },
    { titleKey:'ab.val3.title2', bodyKey:'ab.val3.body2' },
    { titleKey:'ab.val4.title2', bodyKey:'ab.val4.body2' },
  ];

  const infoRows = [
    { labelKey:'ab.row.name',    value: t('ab.row.name.val') },
    { labelKey:'ab.row.abbr',    value: 'IIIS' },
    { labelKey:'ab.row.type',    value: t('ab.row.type.val') },
    { labelKey:'ab.row.loc',     value: t('ab.row.loc.val') },
    { labelKey:'ab.row.langs',   value: t('ab.row.langs.val') },
    { labelKey:'ab.row.scholars',value: scholars.length + t('ab.row.scholars.suffix') },
    { labelKey:'ab.row.cats',    value: categories.length + t('ab.row.cats.suffix') },
  ];

  return(
    <div id="page-about">
      <div className="page-hero">
        <div className="geo-lg"/><div className="page-hero-glow"/>
        <div className="pw">
          <div className="breadcrumb">
            <a href="/" onClick={e=>{e.preventDefault();navigate('/');}}>
              {t('nav.home.label')}
            </a>
            <span>/</span><span>{t('ab.breadcrumb')}</span>
          </div>
          <h1>{t('ab.title1')} <em>{t('ab.title2')}</em></h1>
          <p>{t('ab.subtitle')}</p>
        </div>
      </div>
      <div className="pw">
        <div className="about-grid">
          <div>
            <div className="about-card">
              <h2>{t('ab.who.title2')}</h2>
              <p>{t('ab.who.p1.2')}</p>
              <p>{t('ab.who.p2.2')}</p>
            </div>
            <div className="about-card">
              <h2>{t('ab.values.title2')}</h2>
              <div className="values-list">
                {values.map((v,i)=>(
                  <div key={i} className="value-item">
                    <h4>{t(v.titleKey)}</h4>
                    <p>{t(v.bodyKey)}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="about-card">
              <h2>{t('ab.scholars.title2')}</h2>
              <div style={{display:'flex',flexWrap:'wrap',gap:'1rem',marginTop:'.5rem'}}>
                {scholars.map((s,i)=>(
                  <div key={s.id} className="scholar-mini" onClick={()=>navigate(`/scholars/${s.id}`)}
                    style={{cursor:'pointer',background:'var(--surface)',border:'1px solid var(--brd)',borderRadius:10,padding:'.6rem .9rem',minWidth:170}}>
                    <div className="sm-avi" style={{background:SCHOLAR_COLORS[i%SCHOLAR_COLORS.length],width:72,height:72,overflow:'hidden',display:'flex',alignItems:'center',justifyContent:'center',borderRadius:'50%',fontFamily:'var(--fam-display)',color:'#fff',fontSize:'1.7rem',flexShrink:0}}>
                      {s.photo
                        ? <img src={s.photo.startsWith('http') ? s.photo : STORAGE_BASE + s.photo} alt={s.name} style={{width:'100%',height:'100%',objectFit:'cover'}} />
                        : scholarInitial(s.name)}
                    </div>
                    <div>
                      <div className="sm-name" style={{fontSize:'var(--t-sm)'}}>{s.name.replace(/^(الدكتور|الأستاذ|الشيخ|د\.|أ\.)\s*/,'')}</div>
                      <div className="sm-spec" style={{fontSize:'.72rem'}}>{s.role||t('label.scholar.role')}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="about-card">
              <h2>{t('ab.cats.title2')}</h2>
              <div className="cat-pills" style={{marginTop:'.5rem'}}>
                {categories.map(c=>(
                  <span key={c.id} className="cat-pill" onClick={()=>navigate(`/fatwas?cat=${c.id}`)}>{catName(c, lang)}</span>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="about-sidebar-info">
              <div className="asi-head">{t('ab.info.head')}</div>
              {infoRows.map(row=>(
                <div key={row.labelKey} className="asi-row">
                  <span className="label">{t(row.labelKey)}</span>
                  <span className="value">{row.value}</span>
                </div>
              ))}
            </div>
            <div className="donate-widget">
              <h4>{t('ab.donate.title2')}</h4>
              <p>{t('ab.donate.body2')}</p>
              <a href="/donate" className="dw-btn" onClick={e=>{e.preventDefault();navigate('/donate');}}>
                {t('ab.donate.btn2')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ContactPage() {
  const { t } = useLang();
  const navigate = useNavigate();

  const [form, setForm] = useState({ name:'', email:'', type:'', subject:'', message:'' });
  const [sending, setSending] = useState(false);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      alert(t('con.form.required')); return;
    }
    setSending(true);
    try {
      const res = await fetch(CONTACT_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          ...form,
          type: form.type || t('con.form.type.fatwa'),
        }),
      });
      const json = await res.json().catch(() => ({}));
      if (res.ok && json.success) {
        alert(t('con.form.success'));
        setForm({ name:'', email:'', type:'', subject:'', message:'' });
      } else {
        alert(json.message || t('con.form.error'));
      }
    } catch {
      alert(t('con.form.error'));
    } finally {
      setSending(false);
    }
  };

  return(
    <div id="page-contact">
      <div className="page-hero">
        <div className="geo-lg"/><div className="page-hero-glow"/>
        <div className="pw">
          <div className="breadcrumb">
            <a href="/" onClick={e=>{e.preventDefault();navigate('/');}}>
              {t('nav.home.label')}
            </a>
            <span>/</span><span>{t('con.title1')} {t('con.title2')}</span>
          </div>
          <h1>{t('con.title1')} <em>{t('con.title2')}</em></h1>
          <p>{t('con.subtitle')}</p>
        </div>
      </div>
      <div className="pw">
        <div className="contact-grid">
          <div className="contact-form">
            <h2>{t('con.form.title')}</h2>
            <div className="form-row">
              <div className="form-group"><label>{t('con.form.name')}</label><input type="text" className="form-control" placeholder={t('con.form.name.ph')} value={form.name} onChange={set('name')}/></div>
              <div className="form-group"><label>{t('con.form.email')}</label><input type="email" className="form-control" placeholder="example@email.com" value={form.email} onChange={set('email')}/></div>
            </div>
            <div className="form-group">
              <label>{t('con.form.type')}</label>
              <select className="form-control" value={form.type || t('con.form.type.fatwa')} onChange={set('type')}>
                <option>{t('con.form.type.fatwa')}</option>
                <option>{t('con.form.type.gen')}</option>
                <option>{t('con.form.type.collab')}</option>
              </select>
            </div>
            <div className="form-group"><label>{t('con.form.subject')}</label><input type="text" className="form-control" placeholder={t('con.form.subject.ph')} value={form.subject} onChange={set('subject')}/></div>
            <div className="form-group"><label>{t('con.form.msg')}</label><textarea className="form-control" placeholder={t('con.form.msg.ph')} value={form.message} onChange={set('message')}/></div>
            <button className="submit-btn" onClick={submit} disabled={sending}>{sending ? t('con.form.sending') : t('con.form.send')}</button>
          </div>
          <div>
            <div className="contact-info-box">
              <div className="ci-box">
                <h3>{t('con.info.title')}</h3>
                <div className="ci-item"><div className="ci-icon">📍</div><div><div className="ci-label">{t('con.info.loc')}</div><div className="ci-val">{t('con.info.locVal')}</div></div></div>
                <div className="ci-item"><div className="ci-icon">🌐</div><div><div className="ci-label">{t('con.info.web')}</div><div className="ci-val">www.iiis.us</div></div></div>
                <div className="ci-item"><div className="ci-icon">📱</div><div><div className="ci-label">{t('con.info.zelle')}</div><div className="ci-val" dir="ltr" style={{textAlign:'right'}}>+1 (781) 666-0477</div></div></div>
              </div>
            </div>
            <div className="donate-info-box" style={{marginTop:'1rem'}}>
              <div className="geo-sm"/>
              <h3>{t('con.donate.title')}</h3>
              <p>{t('con.donate.body')}</p>
              <div className="dib-methods">
                <a href="https://buy.stripe.com/4gw16l9yF5QT9IQ4gg" target="_blank" rel="noreferrer">💳 {t('sidebar.donate.stripe')}</a>
                <a href="https://square.link/u/GkkRZRqO" target="_blank" rel="noreferrer">◾ {t('sidebar.donate.square')}</a>
                <a href="#" onClick={e=>{e.preventDefault();navigator.clipboard.writeText('+17816660477').then(()=>alert('✓'));}}>📱 Zelle · +1 (781) 666-0477</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function DonatePage() {
  const { t } = useLang();

  const cards = [
    { icon:'📖', amount:'$25',  labelKey:'don.25.label' },
    { icon:'🌟', amount:'$100', labelKey:'don.100.label', featured:true },
    { icon:'🕌', amount:'$500', labelKey:'don.500.label' },
  ];
  const methods = [
    { icon:'💳', name:'Stripe', descKey:'don.stripe.desc', url:'https://buy.stripe.com/4gw16l9yF5QT9IQ4gg', btnLabel:t('sidebar.donate.stripe') },
    { icon:'◾', name:'Square', descKey:'don.square.desc', url:'https://square.link/u/GkkRZRqO',             btnLabel:t('sidebar.donate.square') },
  ];

  return(
    <div id="page-donate">
      <div className="donate-hero">
        <div className="geo-lg"/>
        <h1>{t('don.title1')} <em>{t('don.title2')}</em></h1>
        <p>{t('don.subtitle')}</p>
      </div>
      <div className="pw">
        <div className="donate-cards">
          {cards.map((c,i)=>(
            <div key={i} className={`donate-card${c.featured?' featured':''}`}>
              <div className="dc-icon">{c.icon}</div>
              <div className="dc-amount">{c.amount}</div>
              <div className="dc-label">{t(c.labelKey)}</div>
              <a href="https://buy.stripe.com/4gw16l9yF5QT9IQ4gg" target="_blank" rel="noreferrer" className="dc-btn">
                {t('don.title1').split(' ')[0]} {c.amount}
              </a>
            </div>
          ))}
        </div>
        <div className="donate-methods-section">
          <h2>{t('don.methods')}</h2>
          <div className="methods-grid">
            {methods.map((m,i)=>(
              <div key={i} className="method-card">
                <div className="mi">{m.icon}</div>
                <h4>{m.name}</h4>
                <p>{t(m.descKey)}</p>
                <a href={m.url} target="_blank" rel="noreferrer" className="dm-btn">{m.btnLabel}</a>
              </div>
            ))}
            <div className="method-card">
              <div className="mi">📱</div>
              <h4>Zelle</h4>
              <p>{t('don.zelle.desc')}</p>
              <p dir="ltr" style={{fontWeight:800,color:'var(--g1)',marginTop:'.4rem',textAlign:'center'}}>+1 (781) 666-0477</p>
              <a href="#" className="dm-btn" onClick={e=>{e.preventDefault();navigator.clipboard.writeText('+17816660477').then(()=>alert('✓'));}}>
                {t('don.zelle.copy')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}